import * as React from 'react'

import Stack from '@mui/material/Stack'
import { useFormikContext } from 'formik'
import Typography from '@mui/material/Typography'
import { TextFieldProps } from '@mui/material/TextField'

import { useData, useHandlers } from './hooks'
import { CalendarDatePicker } from '@user/components/CalendarButton'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

type Props = {
  fieldName: string
  hideOptional: boolean
  textFieldProps?: TextFieldProps
  marginBottom?: any
  tidal?: boolean
  isMobile?: boolean
  show: boolean
  required: boolean
}

export function NextActionDate(props: Props) {
  const { fieldName, tidal, isMobile, show, required } = props

  const { errorText, hasError } = useData({ fieldName })

  const { handleAccept } = useHandlers({ fieldName })

  const { values } = useFormikContext<ILeadFormModel>()
  const { getFormat } = useLocalizationDateFormat()

  return show ? (
    <>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        justifyContent={isMobile ? 'center' : 'space-between'}
        alignItems={isMobile ? 'flex-start' : 'center'}
      >
        <Typography
          sx={{ marginBottom: isMobile ? -0.5 : undefined }}
          variant="subtitle2"
        >
          Next Action Date{required && ' *'}
        </Typography>
        <CalendarDatePicker
          format={getFormat()}
          value={values[fieldName]}
          onAccept={handleAccept}
          tidal={tidal}
          dataTestId="next-action-date-picker"
        />
      </Stack>
      {hasError && (
        <Typography variant="caption" color="error">
          {errorText}
        </Typography>
      )}
    </>
  ) : null
}
